// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call/call_realtime_events.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type {
  Call_FinishReason,
  Call_Status,
  CallMember,
  CallMember_DisplayData,
  CallMember_Role,
  CallMember_Status,
  CallPermission_AccessType,
  CallPermission_RequestStatus,
  CallPermissions,
  CallSettings,
  CallUiConfiguration,
  PersonalizedCallPermissions,
} from './call_model_pb';
import { file_call_call_model } from './call_model_pb';

/**
 * Describes the file call/call_realtime_events.proto.
 */
export const file_call_call_realtime_events: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch9jYWxsL2NhbGxfcmVhbHRpbWVfZXZlbnRzLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCL4GgoRUmVhbHRpbWVDYWxsRXZlbnQSSgoLY2FsbENoYW5nZWQYASABKAsyMy5jb20uZ2VtLmJmZi5jb250cmFjdC5SZWFsdGltZUNhbGxFdmVudC5DYWxsQ2hhbmdlZEgAEk4KDW1lbWJlckNoYW5nZWQYAiABKAsyNS5jb20uZ2VtLmJmZi5jb250cmFjdC5SZWFsdGltZUNhbGxFdmVudC5NZW1iZXJDaGFuZ2VkSAASVAoQbWVtYmVyRm9yY2VNdXRlZBgGIAEoCzI4LmNvbS5nZW0uYmZmLmNvbnRyYWN0LlJlYWx0aW1lQ2FsbEV2ZW50Lk1lbWJlckZvcmNlTXV0ZWRIABJaChNtZW1iZXJGb3JjZUZpbmlzaGVkGAcgASgLMjsuY29tLmdlbS5iZmYuY29udHJhY3QuUmVhbHRpbWVDYWxsRXZlbnQuTWVtYmVyRm9yY2VGaW5pc2hlZEgAElAKDm1lbWJlcldhc0FkZGVkGA0gASgLMjYuY29tLmdlbS5iZmYuY29udHJhY3QuUmVhbHRpbWVDYWxsRXZlbnQuTWVtYmVyV2FzQWRkZWRIABJUChBtZW1iZXJXYXNSZW1vdmVkGA4gASgLMjguY29tLmdlbS5iZmYuY29udHJhY3QuUmVhbHRpbWVDYWxsRXZlbnQuTWVtYmVyV2FzUmVtb3ZlZEgAElwKFGNhbGxSZWNvcmRpbmdTdGFydGVkGA8gASgLMjwuY29tLmdlbS5iZmYuY29udHJhY3QuUmVhbHRpbWVDYWxsRXZlbnQuQ2FsbFJlY29yZGluZ1N0YXJ0ZWRIABJcChRjYWxsUmVjb3JkaW5nU3RvcHBlZBgQIAEoCzI8LmNvbS5nZW0uYmZmLmNvbnRyYWN0LlJlYWx0aW1lQ2FsbEV2ZW50LkNhbGxSZWNvcmRpbmdTdG9wcGVkSAASWAoScGVybWlzc2lvbnNDaGFuZ2VkGBEgASgLMjouY29tLmdlbS5iZmYuY29udHJhY3QuUmVhbHRpbWVDYWxsRXZlbnQuUGVybWlzc2lvbnNDaGFuZ2VkSAASZAoYbWVtYmVyUGVybWlzc2lvbnNDaGFuZ2VkGBIgASgLMkAuY29tLmdlbS5iZmYuY29udHJhY3QuUmVhbHRpbWVDYWxsRXZlbnQuTWVtYmVyUGVybWlzc2lvbnNDaGFuZ2VkSAAScAoebWVtYmVyUGVybWlzc2lvblJlcXVlc3RDcmVhdGVkGBMgASgLMkYuY29tLmdlbS5iZmYuY29udHJhY3QuUmVhbHRpbWVDYWxsRXZlbnQuTWVtYmVyUGVybWlzc2lvblJlcXVlc3RDcmVhdGVkSAAScAoebWVtYmVyUGVybWlzc2lvblJlcXVlc3RDaGFuZ2VkGBQgASgLMkYuY29tLmdlbS5iZmYuY29udHJhY3QuUmVhbHRpbWVDYWxsRXZlbnQuTWVtYmVyUGVybWlzc2lvblJlcXVlc3RDaGFuZ2VkSAASWAoSd2FpdGluZ1Jvb21DaGFuZ2VkGBUgASgLMjouY29tLmdlbS5iZmYuY29udHJhY3QuUmVhbHRpbWVDYWxsRXZlbnQuV2FpdGluZ1Jvb21DaGFuZ2VkSAASZAoYd2FpdGluZ1Jvb21NZW1iZXJDaGFuZ2VkGBYgASgLMkAuY29tLmdlbS5iZmYuY29udHJhY3QuUmVhbHRpbWVDYWxsRXZlbnQuV2FpdGluZ1Jvb21NZW1iZXJDaGFuZ2VkSAASVgoRbWVtYmVyUm9sZUNoYW5nZWQYFyABKAsyOS5jb20uZ2VtLmJmZi5jb250cmFjdC5SZWFsdGltZUNhbGxFdmVudC5NZW1iZXJSb2xlQ2hhbmdlZEgAGpMCCgtDYWxsQ2hhbmdlZBIxCgZzdGF0dXMYAiABKA4yIS5jb20uZ2VtLmJmZi5jb250cmFjdC5DYWxsLlN0YXR1cxI0CghzZXR0aW5ncxgDIAEoCzIiLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNhbGxTZXR0aW5ncxJGChNjYWxsVWlDb25maWd1cmF0aW9uGAQgASgLMikuY29tLmdlbS5iZmYuY29udHJhY3QuQ2FsbFVpQ29uZmlndXJhdGlvbhJCCgxmaW5pc2hSZWFzb24YBSABKA4yJy5jb20uZ2VtLmJmZi5jb250cmFjdC5DYWxsLkZpbmlzaFJlYXNvbkgAiAEBQg8KDV9maW5pc2hSZWFzb24abAoNTWVtYmVyQ2hhbmdlZBIQCghtZW1iZXJJZBgBIAEoAxI3CgZzdGF0dXMYAiABKA4yJy5jb20uZ2VtLmJmZi5jb250cmFjdC5DYWxsTWVtYmVyLlN0YXR1cxIQCghkZXZpY2VJZBgDIAEoCRpCCg5NZW1iZXJXYXNBZGRlZBIwCgZtZW1iZXIYASABKAsyIC5jb20uZ2VtLmJmZi5jb250cmFjdC5DYWxsTWVtYmVyGj8KEE1lbWJlcldhc1JlbW92ZWQSEwoLaW5pdGlhdG9ySWQYASABKAMSFgoOdGFyZ2V0TWVtYmVySWQYAiABKAMaZgoTTWVtYmVyRm9yY2VGaW5pc2hlZBITCgtpbml0aWF0b3JJZBgBIAEoAxIWCg50YXJnZXRNZW1iZXJJZBgCIAEoAxIVCghkZXZpY2VJZBgDIAEoCUgAiAEBQgsKCV9kZXZpY2VJZBpjChBNZW1iZXJGb3JjZU11dGVkEhMKC2luaXRpYXRvcklkGAEgASgDEhYKDnRhcmdldE1lbWJlcklkGAIgASgDEhUKCGRldmljZUlkGAMgASgJSACIAQFCCwoJX2RldmljZUlkGj0KFENhbGxSZWNvcmRpbmdTdGFydGVkEhAKCG1lbWJlcklkGAEgASgDEhMKC3JlY29yZGluZ0lkGAIgASgJGj0KFENhbGxSZWNvcmRpbmdTdG9wcGVkEhAKCG1lbWJlcklkGAEgASgDEhMKC3JlY29yZGluZ0lkGAIgASgJGuABChJQZXJtaXNzaW9uc0NoYW5nZWQSQgoHY2hhbmdlZBgBIAEoCzIxLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlBlcnNvbmFsaXplZENhbGxQZXJtaXNzaW9ucxI2CgdkZWZhdWx0GAIgASgLMiUuY29tLmdlbS5iZmYuY29udHJhY3QuQ2FsbFBlcm1pc3Npb25zEk4KE2RlZmF1bHRQZXJzb25hbGl6ZWQYAyABKAsyMS5jb20uZ2VtLmJmZi5jb250cmFjdC5QZXJzb25hbGl6ZWRDYWxsUGVybWlzc2lvbnMagAEKGE1lbWJlclBlcm1pc3Npb25zQ2hhbmdlZBIQCghtZW1iZXJJZBgBIAEoAxJCCgdjaGFuZ2VkGAIgASgLMjEuY29tLmdlbS5iZmYuY29udHJhY3QuUGVyc29uYWxpemVkQ2FsbFBlcm1pc3Npb25zEg4KBnB1cmdlZBgDIAEoCBpzCh5NZW1iZXJQZXJtaXNzaW9uUmVxdWVzdENyZWF0ZWQSEAoIbWVtYmVySWQYASABKAMSPwoGYWNjZXNzGAIgASgOMi8uY29tLmdlbS5iZmYuY29udHJhY3QuQ2FsbFBlcm1pc3Npb24uQWNjZXNzVHlwZRq6AQoeTWVtYmVyUGVybWlzc2lvblJlcXVlc3RDaGFuZ2VkEhAKCG1lbWJlcklkGAEgASgDEkIKB2NoYW5nZWQYAiABKAsyMS5jb20uZ2VtLmJmZi5jb250cmFjdC5QZXJzb25hbGl6ZWRDYWxsUGVybWlzc2lvbnMSQgoGc3RhdHVzGAMgASgOMjIuY29tLmdlbS5iZmYuY29udHJhY3QuQ2FsbFBlcm1pc3Npb24uUmVxdWVzdFN0YXR1cxppChJXYWl0aW5nUm9vbUNoYW5nZWQSUwoJcmVxdWVzdGVkGAEgAygLMkAuY29tLmdlbS5iZmYuY29udHJhY3QuUmVhbHRpbWVDYWxsRXZlbnQuV2FpdGluZ1Jvb21NZW1iZXJDaGFuZ2VkGpoCChhXYWl0aW5nUm9vbU1lbWJlckNoYW5nZWQSEAoIbWVtYmVySWQYASABKAMSQQoLZGlzcGxheURhdGEYAiABKAsyLC5jb20uZ2VtLmJmZi5jb250cmFjdC5DYWxsTWVtYmVyLkRpc3BsYXlEYXRhEl4KBnN0YXR1cxgDIAEoDjJOLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlJlYWx0aW1lQ2FsbEV2ZW50LldhaXRpbmdSb29tTWVtYmVyQ2hhbmdlZC5SZXF1ZXN0U3RhdHVzIkkKDVJlcXVlc3RTdGF0dXMSDQoJSU5JVElBVEVEEAASDAoIQVBQUk9WRUQQARIMCghSRUpFQ1RFRBACEg0KCVJFUVVFU1RFRBADGngKEU1lbWJlclJvbGVDaGFuZ2VkEhYKDnNvdXJjZU1lbWJlcklkGAEgASgDEhYKDnRhcmdldE1lbWJlcklkGAIgASgDEjMKBHJvbGUYAyABKA4yJS5jb20uZ2VtLmJmZi5jb250cmFjdC5DYWxsTWVtYmVyLlJvbGVCBwoFZXZlbnRCHgoaY29tLmdlbS5iZmYuY2FsbHMuY29udHJhY3RQAWIGcHJvdG8z',
    [file_call_call_model]
  );

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent
 */
export type RealtimeCallEvent = Message<'com.gem.bff.contract.RealtimeCallEvent'> & {
  /**
   * @generated from oneof com.gem.bff.contract.RealtimeCallEvent.event
   */
  event:
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.CallChanged callChanged = 1;
         */
        value: RealtimeCallEvent_CallChanged;
        case: 'callChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.MemberChanged memberChanged = 2;
         */
        value: RealtimeCallEvent_MemberChanged;
        case: 'memberChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.MemberForceMuted memberForceMuted = 6;
         */
        value: RealtimeCallEvent_MemberForceMuted;
        case: 'memberForceMuted';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.MemberForceFinished memberForceFinished = 7;
         */
        value: RealtimeCallEvent_MemberForceFinished;
        case: 'memberForceFinished';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.MemberWasAdded memberWasAdded = 13;
         */
        value: RealtimeCallEvent_MemberWasAdded;
        case: 'memberWasAdded';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.MemberWasRemoved memberWasRemoved = 14;
         */
        value: RealtimeCallEvent_MemberWasRemoved;
        case: 'memberWasRemoved';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.CallRecordingStarted callRecordingStarted = 15;
         */
        value: RealtimeCallEvent_CallRecordingStarted;
        case: 'callRecordingStarted';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.CallRecordingStopped callRecordingStopped = 16;
         */
        value: RealtimeCallEvent_CallRecordingStopped;
        case: 'callRecordingStopped';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.PermissionsChanged permissionsChanged = 17;
         */
        value: RealtimeCallEvent_PermissionsChanged;
        case: 'permissionsChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.MemberPermissionsChanged memberPermissionsChanged = 18;
         */
        value: RealtimeCallEvent_MemberPermissionsChanged;
        case: 'memberPermissionsChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.MemberPermissionRequestCreated memberPermissionRequestCreated = 19;
         */
        value: RealtimeCallEvent_MemberPermissionRequestCreated;
        case: 'memberPermissionRequestCreated';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.MemberPermissionRequestChanged memberPermissionRequestChanged = 20;
         */
        value: RealtimeCallEvent_MemberPermissionRequestChanged;
        case: 'memberPermissionRequestChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.WaitingRoomChanged waitingRoomChanged = 21;
         */
        value: RealtimeCallEvent_WaitingRoomChanged;
        case: 'waitingRoomChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.WaitingRoomMemberChanged waitingRoomMemberChanged = 22;
         */
        value: RealtimeCallEvent_WaitingRoomMemberChanged;
        case: 'waitingRoomMemberChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent.MemberRoleChanged memberRoleChanged = 23;
         */
        value: RealtimeCallEvent_MemberRoleChanged;
        case: 'memberRoleChanged';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.
 * Use `create(RealtimeCallEventSchema)` to create a new message.
 */
export const RealtimeCallEventSchema: GenMessage<RealtimeCallEvent> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.CallChanged
 */
export type RealtimeCallEvent_CallChanged =
  Message<'com.gem.bff.contract.RealtimeCallEvent.CallChanged'> & {
    /**
     * @generated from field: com.gem.bff.contract.Call.Status status = 2;
     */
    status: Call_Status;

    /**
     * @generated from field: com.gem.bff.contract.CallSettings settings = 3;
     */
    settings?: CallSettings;

    /**
     * @generated from field: com.gem.bff.contract.CallUiConfiguration callUiConfiguration = 4;
     */
    callUiConfiguration?: CallUiConfiguration;

    /**
     * @generated from field: optional com.gem.bff.contract.Call.FinishReason finishReason = 5;
     */
    finishReason?: Call_FinishReason;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.CallChanged.
 * Use `create(RealtimeCallEvent_CallChangedSchema)` to create a new message.
 */
export const RealtimeCallEvent_CallChangedSchema: GenMessage<RealtimeCallEvent_CallChanged> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 0);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.MemberChanged
 */
export type RealtimeCallEvent_MemberChanged =
  Message<'com.gem.bff.contract.RealtimeCallEvent.MemberChanged'> & {
    /**
     * @generated from field: int64 memberId = 1;
     */
    memberId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.CallMember.Status status = 2;
     */
    status: CallMember_Status;

    /**
     * @generated from field: string deviceId = 3;
     */
    deviceId: string;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.MemberChanged.
 * Use `create(RealtimeCallEvent_MemberChangedSchema)` to create a new message.
 */
export const RealtimeCallEvent_MemberChangedSchema: GenMessage<RealtimeCallEvent_MemberChanged> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 1);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.MemberWasAdded
 */
export type RealtimeCallEvent_MemberWasAdded =
  Message<'com.gem.bff.contract.RealtimeCallEvent.MemberWasAdded'> & {
    /**
     * @generated from field: com.gem.bff.contract.CallMember member = 1;
     */
    member?: CallMember;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.MemberWasAdded.
 * Use `create(RealtimeCallEvent_MemberWasAddedSchema)` to create a new message.
 */
export const RealtimeCallEvent_MemberWasAddedSchema: GenMessage<RealtimeCallEvent_MemberWasAdded> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 2);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.MemberWasRemoved
 */
export type RealtimeCallEvent_MemberWasRemoved =
  Message<'com.gem.bff.contract.RealtimeCallEvent.MemberWasRemoved'> & {
    /**
     * @generated from field: int64 initiatorId = 1;
     */
    initiatorId: bigint;

    /**
     * @generated from field: int64 targetMemberId = 2;
     */
    targetMemberId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.MemberWasRemoved.
 * Use `create(RealtimeCallEvent_MemberWasRemovedSchema)` to create a new message.
 */
export const RealtimeCallEvent_MemberWasRemovedSchema: GenMessage<RealtimeCallEvent_MemberWasRemoved> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 3);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.MemberForceFinished
 */
export type RealtimeCallEvent_MemberForceFinished =
  Message<'com.gem.bff.contract.RealtimeCallEvent.MemberForceFinished'> & {
    /**
     * @generated from field: int64 initiatorId = 1;
     */
    initiatorId: bigint;

    /**
     * @generated from field: int64 targetMemberId = 2;
     */
    targetMemberId: bigint;

    /**
     * @generated from field: optional string deviceId = 3;
     */
    deviceId?: string;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.MemberForceFinished.
 * Use `create(RealtimeCallEvent_MemberForceFinishedSchema)` to create a new message.
 */
export const RealtimeCallEvent_MemberForceFinishedSchema: GenMessage<RealtimeCallEvent_MemberForceFinished> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 4);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.MemberForceMuted
 */
export type RealtimeCallEvent_MemberForceMuted =
  Message<'com.gem.bff.contract.RealtimeCallEvent.MemberForceMuted'> & {
    /**
     * @generated from field: int64 initiatorId = 1;
     */
    initiatorId: bigint;

    /**
     * @generated from field: int64 targetMemberId = 2;
     */
    targetMemberId: bigint;

    /**
     * @generated from field: optional string deviceId = 3;
     */
    deviceId?: string;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.MemberForceMuted.
 * Use `create(RealtimeCallEvent_MemberForceMutedSchema)` to create a new message.
 */
export const RealtimeCallEvent_MemberForceMutedSchema: GenMessage<RealtimeCallEvent_MemberForceMuted> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 5);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.CallRecordingStarted
 */
export type RealtimeCallEvent_CallRecordingStarted =
  Message<'com.gem.bff.contract.RealtimeCallEvent.CallRecordingStarted'> & {
    /**
     * @generated from field: int64 memberId = 1;
     */
    memberId: bigint;

    /**
     * @generated from field: string recordingId = 2;
     */
    recordingId: string;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.CallRecordingStarted.
 * Use `create(RealtimeCallEvent_CallRecordingStartedSchema)` to create a new message.
 */
export const RealtimeCallEvent_CallRecordingStartedSchema: GenMessage<RealtimeCallEvent_CallRecordingStarted> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 6);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.CallRecordingStopped
 */
export type RealtimeCallEvent_CallRecordingStopped =
  Message<'com.gem.bff.contract.RealtimeCallEvent.CallRecordingStopped'> & {
    /**
     * @generated from field: int64 memberId = 1;
     */
    memberId: bigint;

    /**
     * @generated from field: string recordingId = 2;
     */
    recordingId: string;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.CallRecordingStopped.
 * Use `create(RealtimeCallEvent_CallRecordingStoppedSchema)` to create a new message.
 */
export const RealtimeCallEvent_CallRecordingStoppedSchema: GenMessage<RealtimeCallEvent_CallRecordingStopped> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 7);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.PermissionsChanged
 */
export type RealtimeCallEvent_PermissionsChanged =
  Message<'com.gem.bff.contract.RealtimeCallEvent.PermissionsChanged'> & {
    /**
     * @generated from field: com.gem.bff.contract.PersonalizedCallPermissions changed = 1;
     */
    changed?: PersonalizedCallPermissions;

    /**
     * @generated from field: com.gem.bff.contract.CallPermissions default = 2;
     */
    default?: CallPermissions;

    /**
     * @generated from field: com.gem.bff.contract.PersonalizedCallPermissions defaultPersonalized = 3;
     */
    defaultPersonalized?: PersonalizedCallPermissions;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.PermissionsChanged.
 * Use `create(RealtimeCallEvent_PermissionsChangedSchema)` to create a new message.
 */
export const RealtimeCallEvent_PermissionsChangedSchema: GenMessage<RealtimeCallEvent_PermissionsChanged> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 8);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.MemberPermissionsChanged
 */
export type RealtimeCallEvent_MemberPermissionsChanged =
  Message<'com.gem.bff.contract.RealtimeCallEvent.MemberPermissionsChanged'> & {
    /**
     * @generated from field: int64 memberId = 1;
     */
    memberId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.PersonalizedCallPermissions changed = 2;
     */
    changed?: PersonalizedCallPermissions;

    /**
     * @generated from field: bool purged = 3;
     */
    purged: boolean;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.MemberPermissionsChanged.
 * Use `create(RealtimeCallEvent_MemberPermissionsChangedSchema)` to create a new message.
 */
export const RealtimeCallEvent_MemberPermissionsChangedSchema: GenMessage<RealtimeCallEvent_MemberPermissionsChanged> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 9);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.MemberPermissionRequestCreated
 */
export type RealtimeCallEvent_MemberPermissionRequestCreated =
  Message<'com.gem.bff.contract.RealtimeCallEvent.MemberPermissionRequestCreated'> & {
    /**
     * @generated from field: int64 memberId = 1;
     */
    memberId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.CallPermission.AccessType access = 2;
     */
    access: CallPermission_AccessType;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.MemberPermissionRequestCreated.
 * Use `create(RealtimeCallEvent_MemberPermissionRequestCreatedSchema)` to create a new message.
 */
export const RealtimeCallEvent_MemberPermissionRequestCreatedSchema: GenMessage<RealtimeCallEvent_MemberPermissionRequestCreated> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 10);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.MemberPermissionRequestChanged
 */
export type RealtimeCallEvent_MemberPermissionRequestChanged =
  Message<'com.gem.bff.contract.RealtimeCallEvent.MemberPermissionRequestChanged'> & {
    /**
     * @generated from field: int64 memberId = 1;
     */
    memberId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.PersonalizedCallPermissions changed = 2;
     */
    changed?: PersonalizedCallPermissions;

    /**
     * @generated from field: com.gem.bff.contract.CallPermission.RequestStatus status = 3;
     */
    status: CallPermission_RequestStatus;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.MemberPermissionRequestChanged.
 * Use `create(RealtimeCallEvent_MemberPermissionRequestChangedSchema)` to create a new message.
 */
export const RealtimeCallEvent_MemberPermissionRequestChangedSchema: GenMessage<RealtimeCallEvent_MemberPermissionRequestChanged> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 11);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.WaitingRoomChanged
 */
export type RealtimeCallEvent_WaitingRoomChanged =
  Message<'com.gem.bff.contract.RealtimeCallEvent.WaitingRoomChanged'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.RealtimeCallEvent.WaitingRoomMemberChanged requested = 1;
     */
    requested: RealtimeCallEvent_WaitingRoomMemberChanged[];
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.WaitingRoomChanged.
 * Use `create(RealtimeCallEvent_WaitingRoomChangedSchema)` to create a new message.
 */
export const RealtimeCallEvent_WaitingRoomChangedSchema: GenMessage<RealtimeCallEvent_WaitingRoomChanged> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 12);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.WaitingRoomMemberChanged
 */
export type RealtimeCallEvent_WaitingRoomMemberChanged =
  Message<'com.gem.bff.contract.RealtimeCallEvent.WaitingRoomMemberChanged'> & {
    /**
     * @generated from field: int64 memberId = 1;
     */
    memberId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.CallMember.DisplayData displayData = 2;
     */
    displayData?: CallMember_DisplayData;

    /**
     * @generated from field: com.gem.bff.contract.RealtimeCallEvent.WaitingRoomMemberChanged.RequestStatus status = 3;
     */
    status: RealtimeCallEvent_WaitingRoomMemberChanged_RequestStatus;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.WaitingRoomMemberChanged.
 * Use `create(RealtimeCallEvent_WaitingRoomMemberChangedSchema)` to create a new message.
 */
export const RealtimeCallEvent_WaitingRoomMemberChangedSchema: GenMessage<RealtimeCallEvent_WaitingRoomMemberChanged> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 13);

/**
 *
 * APPROVED
 * /
 * +-> INITIATED -> REQUESTED
 * |                   |     \
 * |                   |      REJECTED
 * +-------------------+
 *
 *
 * @generated from enum com.gem.bff.contract.RealtimeCallEvent.WaitingRoomMemberChanged.RequestStatus
 */
export enum RealtimeCallEvent_WaitingRoomMemberChanged_RequestStatus {
  /**
   * @generated from enum value: INITIATED = 0;
   */
  INITIATED = 0,

  /**
   * @generated from enum value: APPROVED = 1;
   */
  APPROVED = 1,

  /**
   * @generated from enum value: REJECTED = 2;
   */
  REJECTED = 2,

  /**
   * @generated from enum value: REQUESTED = 3;
   */
  REQUESTED = 3,
}

/**
 * Describes the enum com.gem.bff.contract.RealtimeCallEvent.WaitingRoomMemberChanged.RequestStatus.
 */
export const RealtimeCallEvent_WaitingRoomMemberChanged_RequestStatusSchema: GenEnum<RealtimeCallEvent_WaitingRoomMemberChanged_RequestStatus> =
  /*@__PURE__*/
  enumDesc(file_call_call_realtime_events, 0, 13, 0);

/**
 * @generated from message com.gem.bff.contract.RealtimeCallEvent.MemberRoleChanged
 */
export type RealtimeCallEvent_MemberRoleChanged =
  Message<'com.gem.bff.contract.RealtimeCallEvent.MemberRoleChanged'> & {
    /**
     * @generated from field: int64 sourceMemberId = 1;
     */
    sourceMemberId: bigint;

    /**
     * @generated from field: int64 targetMemberId = 2;
     */
    targetMemberId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.CallMember.Role role = 3;
     */
    role: CallMember_Role;
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeCallEvent.MemberRoleChanged.
 * Use `create(RealtimeCallEvent_MemberRoleChangedSchema)` to create a new message.
 */
export const RealtimeCallEvent_MemberRoleChangedSchema: GenMessage<RealtimeCallEvent_MemberRoleChanged> =
  /*@__PURE__*/
  messageDesc(file_call_call_realtime_events, 0, 14);
